import { render, staticRenderFns } from "./MissingDonors.vue?vue&type=template&id=cb62aad0"
import script from "./MissingDonors.vue?vue&type=script&lang=js"
export * from "./MissingDonors.vue?vue&type=script&lang=js"
import style0 from "./MissingDonors.vue?vue&type=style&index=0&id=cb62aad0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports